import * as React from 'react';
import { EPinsUpdateTrigger, getMapTelemetry, getMapTelemetryConfig } from 'shared/map-search/services/mapTelemetry';

import { useApplicationContext } from '../../ApplicationContext';
import { useMapContext } from '../context';

/**
 * Открывает замер SLI 2 — времени обновления пинов после взаимодействия с картой.
 *
 * Момент окончания взаимодействия определяем по actionend с окном тишины: у зума колесом мыши
 * явного конца нет, это серия событий, и без паузы каждый щелчок стал бы отдельным замером.
 * Закрывает замер слой пинов, когда отрисует обновлённые данные.
 */
export const MapInteractionTelemetry: React.FC = () => {
  const { config } = useApplicationContext();
  const { map } = useMapContext();

  React.useEffect(() => {
    const mapTelemetry = getMapTelemetry();
    const { interactionQuietWindowMs } = getMapTelemetryConfig(config);
    let quietWindowTimeout: ReturnType<typeof setTimeout> | undefined;
    let zoomBeforeInteraction = map.getZoom();

    const handleActionEnd = () => {
      clearTimeout(quietWindowTimeout);

      quietWindowTimeout = setTimeout(() => {
        const zoomAfterInteraction = map.getZoom();
        const trigger =
          zoomAfterInteraction === zoomBeforeInteraction ? EPinsUpdateTrigger.Pan : EPinsUpdateTrigger.Zoom;

        zoomBeforeInteraction = zoomAfterInteraction;
        mapTelemetry.startPinsUpdate(trigger);
      }, interactionQuietWindowMs);
    };

    map.events.add('actionend', handleActionEnd);

    return () => {
      clearTimeout(quietWindowTimeout);
      map.events.remove('actionend', handleActionEnd);
    };
  }, [map, config]);

  return null;
};
